module.exports = "//static.hsappstatic.net/UserPreferencesUI/static-1.25346/images/unplug.svg"